import React, { useState } from "react";
import { Grid, Button, Box, Typography, IconButton } from "@mui/material";
import RegularizationAccordion from "@/pages/attendance/component/Accordion";
import DetailRow from "@/pages/attendance/component/DetailRow";
import DisplayDates from "@/pages/attendance/component/DisplayDates";
import renderActions from "@/pages/attendance/component/RenderActions";
import { Link, } from "react-router-dom";
import { ArrowBackIosNewOutlinedIcon } from "@/icons";
import ViewRegularizationList from "../regularization/ViewRegularizationList/ViewRegularizationList";
import Loader from "@/components/loader";

// Example styles for buttons
const styles = {

  viewButton: {
    backgroundColor: (theme) => theme.palette.BudgieThemeColor.Primary[1200],
    color: (theme) => theme.palette.BudgieThemeColor.BaseWhite,
    m: (theme) => theme.spacing(0, 1),
    borderRadius: (theme) => theme.shape.s,
  },

};

const PendingApprovals = ({ approvalsRecords, isLoadingHistory }) => {
  const [showViewList, setShowViewList] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const formatDate = (dateString) => {
    return new Date(dateString)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .split("/")
      .join("/");
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "REG":
        return "Regularization";
      case "WFH":
        return "Work From Home";
      case "OD":
        return "On Duty";
      default:
        return "";
    }
  };

  const renderDetails = (item) => {
    const workTypes = item.appliedRegularizations
      ?.map((reg) => getStatusLabel(reg?.regularizationStatus))
      .filter((type) => type && type.trim() !== "")
      .join(", ");

    const inOutTimes = item.appliedRegularizations
      ?.map((reg) => {
        const start = reg.startTime?.slice(0, 5) || "--:--";
        const end = reg.endTime?.slice(0, 5) || "--:--";
        return `${start} - ${end}`;
      })
      .join(", ") || "-";

    const employeeReasons = item.appliedRegularizations
      ?.map((reg) => reg.reason || "-")
      .join(", ");

    return (
      <Grid container spacing={2}>
        <DetailRow label="Work Type" value={workTypes} />
        <DetailRow label="No. of days" value={item.noOfDays || "-"} />
        <DetailRow label="Applied On" value={formatDate(item.appliedDate)} />
        <DetailRow
          label="Applied For"
          value={<DisplayDates dates={item.regularizationDates} />}
        />
        <DetailRow label="IN/OUT Time" value={inOutTimes} />
        <DetailRow label="Employee Reason" value={employeeReasons || "-"} />
        {item.remarks && item.remarks.trim() !== "" && (
          <DetailRow label="Employee Remarks" value={item.remarks} />
        )}
      </Grid>
    );
  };


  const actions = (item) => [
    {
      label: "View",
      variant: "outlined",
      sx: {
        /* additional styles */
        backgroundColor: (theme) =>
          theme.palette.BudgieThemeColor.Primary[1200],
        color: (theme) => theme.palette.BudgieThemeColor.BaseWhite,
        p: (theme) => theme.spacing(1, 2),
        m: (theme) => theme.spacing(0, 1),
        borderRadius: (theme) => theme.shape.s,
      },
      hoverSx: {
        /* additional styles */
        backgroundColor: (theme) =>
          theme.palette.BudgieThemeColor.Primary[1200],
        color: (theme) => theme.palette.BudgieThemeColor.BaseWhite,
        borderColor: (theme) => theme.palette.BudgieThemeColor.Primary[600],
      },
      onclick: () => {
        setShowViewList(true);
        setSelectedRecord(item);
      },
    },
  ];
  const getTitle = (item) =>
    `${item.employeeName}(${item.empId})`;


  return (
    <>
      {isLoadingHistory ? (
        <Loader />
      ) : (
        <>
          {showViewList ? (
            <>
              <Typography variant="h4">
                <IconButton
                  component={Link}
                  to="/attendance/regularization"
                  color="primary"
                  onClick={() => setShowViewList(false)}
                >
                  <ArrowBackIosNewOutlinedIcon />
                </IconButton>
                Review Regularizations
              </Typography>
              <ViewRegularizationList setShowViewList={setShowViewList} selectedRecord={selectedRecord} />
            </>
          ) : (
            <RegularizationAccordion
              showChip={true}
              showActions={true}
              items={approvalsRecords}
              renderDetails={renderDetails}
              renderActions={(item) => renderActions(item, actions(item))}
              containerSpacing={(theme) => theme.spacing(2)}
              detailsGridProps={{ xs: 12, sm: 9 }}
              actionsGridProps={{ xs: 12, sm: 3 }}
              accordionProps={{ elevation: 1 }}
              getTitle={getTitle} // Pass the function to get title
              getChipLabel={(item) => item.status}
              getChipStyle={(item) => {
                switch (item.status) {
                  case "Approved":
                    return {
                      backgroundColor: "#ECFDF3",
                      color: "#1DA850",
                      borderColor: "#A9D9BD",
                    };
                  case "Partially Approved":
                    return {
                      backgroundColor: "#ECFDF3",
                      color: "#1DA850",
                      borderColor: "#A9D9BD",
                    };
                  case "Rejected":
                    return {
                      backgroundColor: "#FEF3F2",
                      color: "#EC2424",
                      borderColor: "#F9B4B4",
                    };
                  default:
                    return {};
                }
              }}

            />
          )}
        </>
      )}
    </>

  );
};

export default PendingApprovals;
